


















































































































































































import {
  ApiCommodityCommodityMarketingDetailResponse,
  apiMarketingCouponReceiveOpen,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent, useNewRoute } from '@/hooks'
import { RequiredDeep } from 'vtils/types'
import { submit } from '@/utils'

export default defineClassComponent<{
  data: any
  zIndex?: number
}>(
  {
    props: ['data', 'zIndex'],
  },
  ({ props, ctx }) =>
    class {
      constructor() {
        // 弹窗视为一个新路由
        useNewRoute(this.visible)
      }

      // 弹窗是否可见
      visible = ref(false)

      // 营销数据
      marketingData = computed(() => props.data)

      // 格式化优惠券
      formatCoupon = (
        coupon: RequiredDeep<ApiCommodityCommodityMarketingDetailResponse>['fullCoupons'][0],
        可用样式 = false,
      ) => {
        return coupon.minPoint === 0
          ? `无门槛${可用样式 ? '' : `减${coupon.discountAmt}元`}`
          : `满${coupon.minPoint}元${
              可用样式 ? '可用' : `减${coupon.discountAmt}元`
            }`
      }

      // 点击优惠
      handleTriggerClick = () => {
        this.visible.value = !this.visible.value
      }

      // 点击去使用优惠券
      handleUseClick = () => {
        this.visible.value = false
      }

      // 点击领取优惠券
      handleGetClick = (
        item: RequiredDeep<ApiCommodityCommodityMarketingDetailResponse>['fullCoupons'][0],
      ) => {
        submit(async $ => {
          $.start('领取中...')
          await apiMarketingCouponReceiveOpen(
            {
              couponActId: item.activityId,
            },
            {
              errorMessageMap: {
                '没领到哦，你的单张券已领取达到上限': [1001, 1007, 1008],
                '活动已结束，无法继续领取': [1003, 1004, 1005],
                '领取失败，当前不在领取时段内': [1009],
                '领取失败，不符合领券要求': [1012],
              },
            },
          )
          ctx.$emit('refresh')
          await $.success('领取成功')
        })
      }
    },
)
